import { EventEmitter } from '@root/Services/EventEmitter';
import { injectable } from 'tsyringe';

@injectable()
export class BillingInvoiceAdminPanelModel {
    public adjustmentChanged = new EventEmitter<boolean>(false);
}
